import React from 'react';
import './SectionHeader.css'

const SectionTitle = (props) => {
    return ( 
        <p className='SectionTitle'> {props.SectionTitle} <span className='Highlighted'>{props.HighlightedWord}</span></p>
     );
}
 
export default SectionTitle;